import { AlertType } from '../enums/AlertType';
import { AlertMessage } from './AlertMessage';

export interface Alert {
  type: AlertType;
  title: AlertMessage;
  message: AlertMessage;
  time?: number;
}
